import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import {store} from './store/store'
import router from "./router/router";
// import VueI18n from 'vue-i18n'
import i18n from './i18n'
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import VueScrollableTabs from "vue-scrollable-tabs";
import Skeleton from 'vue-loading-skeleton';
import Toast from "vue-toastification";
import * as Sentry from "@sentry/vue";

import '../src/scss/app.scss'
import "vue-toastification/dist/index.css";

new Vue({
    el: "#app",
    render: h => h(App),
    store: store,
    i18n,
    router
})


Vue.use(Router)
// Vue.use(VueI18n)
Vue.use(VueBottomSheet);
Vue.use(VueScrollableTabs);
Vue.use(Skeleton);

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost"],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const toastOptions = {
    position: "bottom-center",
};
Vue.use(Toast, toastOptions);

Vue.config.productionTip = false;

